import React from 'react'
import styled from 'styled-components'
import { CheckIcon } from '../../atoms/CheckIcon'
import { SubTitle } from '../../atoms/SubTitle'
import { Title } from '../../atoms/Title'

export const TrialHeaderDescription = () => {
  return (
    <>
      <Title>ハンディを無料でお試しできます</Title>
      <SubTitle>会計まで一連の機能を体験できます。</SubTitle>
      <DescriptionBlock>
        <DescriptionLine>
          <CheckIcon />
          ハンディで注文
          <SubDescription>（1日5回まで）</SubDescription>
        </DescriptionLine>
        <DescriptionLine>
          <CheckIcon />
          キッチンモニターで調理・配膳管理
        </DescriptionLine>
        <DescriptionLine>
          <CheckIcon />
          Airレジ、レストランボードと連携
        </DescriptionLine>
      </DescriptionBlock>
      <SecondDescription>
        すべての機能をご利用いただくにはお申込みが必要です。
      </SecondDescription>
      <CheckDescription>
        導入相談ご希望の場合は、下記にチェックしてください。
      </CheckDescription>
    </>
  )
}

const DescriptionBlock = styled.div`
  margin-top: 16px;
  width: 100%;
  background: #fafafa;
  border-radius: 4;
  text-align: left;
`

const DescriptionLine = styled.div`
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 300;
`

const SubDescription = styled.span`
  margin-left: 4px;
  font-size: 10px;
  font-weight: 300;
`

const SecondDescription = styled.div`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

const CheckDescription = styled.div`
  margin-top: 8px;
  font-size: 11px;
  font-weight: 300;
`
